<template>
  <div class="image-container">
    <div v-if="!isImageLoaded && imgUrl" class="loading-placeholder">
      <div class="skeleton-loader"></div>
    </div>
    <div v-else-if="!imgUrl" class="empty-state">
      <div class="empty-icon">📷</div>
      <p class="empty-text">暂无图片</p>
    </div>
    <img
      v-show="isImageLoaded && imgUrl"
      class="img"
      :style="{ opacity: isImageLoaded ? 1 : 0 }"
      :src="imgUrl"
      @load="onImageLoad"
      @error="onImageError"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "@/utils/router";

const route = useRoute();
const imgUrl = ref("");
const isImageLoaded = ref(false);
const hasError = ref(false);

if (route.query && route.query.imgUrl) {
  imgUrl.value = route.query.imgUrl;
}

const onImageLoad = () => {
  isImageLoaded.value = true;
  hasError.value = false;
};

const onImageError = () => {
  isImageLoaded.value = false;
  hasError.value = true;
};
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img {
  width: 100%;
  min-height: 100vh;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.img[v-show="true"] {
  opacity: 1;
}

.loading-placeholder {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.skeleton-loader {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.empty-text {
  color: #666;
  font-size: 14px;
  margin: 0;
}
</style>
